import useNavigation from '@/hooks/useNavigation';

const useParams = <Params extends { [K in keyof Params]?: string | string[] } = {}>() => {
  return useNavigation().query as Params;
};

export default useParams;
